import { getSite, getSiteId } from "@/src/utils/configUtils";
import { create } from "zustand";
import { createJSONStorage, devtools, persist } from "zustand/middleware";
import { Common, initialState } from "./initialState";

export const useCommonStore = create<Common>()(
    devtools(
        persist(
            (set, get) => ({
                ...initialState,
                setCommonData: (domain) => {
                    const data = {
                        domain,
                        site: getSite(domain),
                        siteId: getSiteId(domain),
                    };
                    set(data);
                },
            }),
            {
                name: "common-storage",
                storage: createJSONStorage(() => sessionStorage),
            },
        ),
        {
            name: "common-store",
        },
    ),
);
